export default __webpack_public_path__ + "static/media/Neo Men.14a8f2b3.jpg";